(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaAmazonDeleteController',CampagnaAmazonDeleteController);

    CampagnaAmazonDeleteController.$inject = ['$uibModalInstance', 'entity', 'CampagnaAmazon'];

    function CampagnaAmazonDeleteController($uibModalInstance, entity, CampagnaAmazon) {
        var vm = this;

        vm.campagnaAmazon = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CampagnaAmazon.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
